type Unit = string | null | undefined;

function lowerUnit(unit: Unit): string {
  return (unit ?? "").trim().toLowerCase();
}

export function poundsToKilograms(value: number): number {
  return value * 0.45359237;
}

export function gramsToKilograms(value: number): number {
  return value / 1000;
}

export function milesToMeters(value: number): number {
  return value * 1609.344;
}

export function fahrenheitToCelsius(value: number): number {
  return (value - 32) * (5 / 9);
}

export function normalizePercentage(value: number, unit: Unit): number {
  const normalizedUnit = lowerUnit(unit);
  if (normalizedUnit === "%" || normalizedUnit === "percent") {
    return value;
  }
  if (value <= 1) {
    return value * 100;
  }
  return value;
}

export function normalizeMassToKilograms(value: number, unit: Unit): number | null {
  const normalizedUnit = lowerUnit(unit);
  if (normalizedUnit === "kg" || normalizedUnit === "kilogram" || normalizedUnit === "kilograms") return value;
  if (normalizedUnit === "lb" || normalizedUnit === "lbs" || normalizedUnit === "pound" || normalizedUnit === "pounds") return poundsToKilograms(value);
  if (normalizedUnit === "g" || normalizedUnit === "gram" || normalizedUnit === "grams") return gramsToKilograms(value);
  return null;
}

export function normalizeDistanceToMeters(value: number, unit: Unit): number | null {
  const normalizedUnit = lowerUnit(unit);
  if (normalizedUnit === "m" || normalizedUnit === "meter" || normalizedUnit === "meters") return value;
  if (normalizedUnit === "km" || normalizedUnit === "kilometer" || normalizedUnit === "kilometers") return value * 1000;
  if (normalizedUnit === "mi" || normalizedUnit === "mile" || normalizedUnit === "miles") return milesToMeters(value);
  return null;
}

export function normalizeTemperatureToCelsius(value: number, unit: Unit): number | null {
  const normalizedUnit = lowerUnit(unit);
  if (normalizedUnit === "degc" || normalizedUnit === "c" || normalizedUnit === "celsius") return value;
  if (normalizedUnit === "degf" || normalizedUnit === "f" || normalizedUnit === "fahrenheit") return fahrenheitToCelsius(value);
  return null;
}

export function normalizeCount(value: number): number {
  return value;
}

export function roundNumber(value: number, decimals = 3): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}
